import { Pipe, PipeTransform } from "@angular/core";
import { Product } from "../classes/product";

@Pipe({
  name: "discount",
})
export class DiscountPipe implements PipeTransform {
  transform(value: any, args?: Product): any {
    const optionsValue = args.opcoes?.length ? args.opcoes.reduce((total, produto) => total + produto.valor, 0) : 0;

    const price = args.discount
      ? value - (value * args.discount) / 100
      : value;
    return price + optionsValue;
  }
}


